import React, { useEffect, useState } from "react";
import axiosInstance from "../axiosInstance";
import {
  Box,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";

const apiUrl = process.env.REACT_APP_API_URL;

const AccessManagement = () => {
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [pages, setPages] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(false);

  // Authorization header
  const token = localStorage.getItem("authToken");
  const authHeader = {
    headers: {
      Authorization: `Bearer ${token}`,
      "X-Requested-Page": window.location.pathname,
    },
  };

  useEffect(() => {
    fetchRoles();
    fetchPages();
  }, []);

  const fetchRoles = async () => {
    try {
      const response = await axiosInstance.get(`${apiUrl}/roles`, authHeader);
      setRoles(response.data.roles);
    } catch (error) {
      toast.error("Failed to fetch roles");
    }
  };

  const fetchPages = async () => {
    try {
      const response = await axiosInstance.get(
        `${apiUrl}/access-manage`,
        authHeader
      );
      setPages(response.data.pages);
    } catch (error) {
      toast.error("Failed to fetch pages");
    }
  };

  const fetchPermissions = async (roleId) => {
    if (!roleId) return;
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `${apiUrl}/permissions?role=${roleId}`,
        authHeader
      );

      // Convert array of allowed pages into an object for checkbox state
      const permissionsObj = response.data.permissions.reduce((acc, page) => {
        acc[page] = true; // Mark existing permissions as checked
        return acc;
      }, {});

      setPermissions(permissionsObj);
    } catch (error) {
      toast.error("Failed to fetch permissions");
    }
    setLoading(false);
  };

  const handleRoleChange = (event) => {
    const roleId = event.target.value;
    setSelectedRole(roleId);
    fetchPermissions(roleId);
  };

  const handlePermissionChange = (route) => {
    setPermissions((prev) => ({
      ...prev,
      [route]: !prev[route], // Toggle permission
    }));
  };

  const savePermissions = async () => {
    setLoading(true);
// console.log(Object.keys(permissions).filter((route) => permissions[route]));
    try {
      await axiosInstance.post(
        `${apiUrl}/permissions`,
        {
          roleId: selectedRole,
          permissions: Object.keys(permissions).filter((route) => permissions[route]), // Save only checked ones
        },
        authHeader
      );
      toast.success("Permissions updated successfully");
    } catch (error) {
      toast.error("Failed to update permissions");
    }
    setLoading(false);
  };

  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>
        Access Management
      </Typography>
      <FormControl fullWidth margin="normal">
        <InputLabel>Select Role</InputLabel>
        <Select value={selectedRole} onChange={handleRoleChange}>
          {roles.map((role) => (
            <MenuItem key={role.id} value={role.id}>
              {role.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {loading ? (
        <CircularProgress />
      ) : (
        <Box mt={2}>
          {pages.map((category) => (
            <Box key={category.category} mb={2}>
              <Typography variant="h6">{category.category}</Typography>
              {category.pages.map((page) => (
                <FormControlLabel
                  key={page.route}
                  control={
                    <Checkbox
                      checked={permissions[page.route] || false}
                      onChange={() => handlePermissionChange(page.route)}
                    />
                  }
                  label={page.name}
                />
              ))}
            </Box>
          ))}
        </Box>
      )}

      <Button
        variant="contained"
        color="primary"
        onClick={savePermissions}
        disabled={!selectedRole || loading}
      >
        Save Permissions
      </Button>
    </Box>
  );
};

export default AccessManagement;
